// extracted by mini-css-extract-plugin
export default {"hzhb":"style_hzhb_yv-3G"};